import React from 'react';
import { queryCache } from 'react-query';
import { QKeys } from 'src/api/types';
import { GTCInlineWrapper } from 'src/components/GenericTable';
import { useGTPortalTarget } from 'src/components/GenericTable/GTContext';
import { StrategySelect } from 'src/components/select';
import { useUpsertControlMutation } from 'src/graphql/_generated';
import { useAuth } from 'src/state/auth';

interface StrategyCellProps {
  controlId: string;
  value: string | null | undefined;
}

export const StrategyCell: React.FC<StrategyCellProps> = ({ controlId, value }) => {
  const [upsertControl, { loading }] = useUpsertControlMutation();
  const { workspaceId } = useAuth();
  const portalTarget = useGTPortalTarget();

  const handleChange = (option: { value: string }) => {
    if (option.value === value) return;
    upsertControl({
      variables: {
        controlData: { id: controlId, strategy: option.value },
        workspaceId,
      },
      update: (cache) => {
        cache.modify({
          id: cache.identify({ __typename: 'Control', id: controlId }),
          fields: {
            strategy: () => option.value,
          },
        });
      },
      onCompleted: () => queryCache.invalidateQueries([QKeys.Audit]),
    });
  };

  return (
    <GTCInlineWrapper>
      <StrategySelect value={value} onChange={handleChange} disabled={loading} menuPortalTarget={portalTarget} />
    </GTCInlineWrapper>
  );
};
